/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPipette: {
  name: 'pipette';
  data: string;
} = {
  name: 'pipette',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.414 5a2 2 0 0 0-2.828 0L12 6.586l-1.293-1.293a1 1 0 0 0-1.414 1.414L10.586 8l-5.08 5.079A2 2 0 0 0 4.96 14.1l-.646 3.232a2 2 0 0 0 2.353 2.353l3.232-.646a2 2 0 0 0 1.022-.547L16 13.414l1.293 1.293a1 1 0 0 0 1.414-1.414L17.414 12 19 10.414a2 2 0 0 0 0-2.828L16.414 5ZM16 10.586 17.586 9 15 6.414 13.414 8 16 10.586Zm-4-1.172-5.079 5.08-.646 3.231 3.232-.646L14.586 12 12 9.414Z" fill="currentColor"/></svg>`,
};
